import { get, getDatabase, off, onValue, push, query, ref, remove, set, collection, child, update } from "firebase/database"
import app from "../Firebase/Firebase";
import { customAlphabet } from "nanoid";
import { getAuthHeaders, authenticatedFetch } from "../utils/apiUtils";


const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 6)

//GET calls
export const fetchDeployments = async (authCtx) => {
  try {
    const orgId = authCtx?.orgId || localStorage.getItem('orgId');
    if (!orgId) {
      throw new Error('orgId is not found in localStorage and in authCtx');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}/deployments`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    if (result.status === "success") {
      return result.data;
    }
    else {
      throw new Error(result.message || 'Unexpected response status');
    }
  }
  catch (error) {
    // console.error('Failed to fetch client details:', error.message);
  }
};

export const fetchmemberDetails = async ({ assessmentId }) => {
  try {
    if (!assessmentId) {
      throw new Error('Id not found');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v3/user/assessment/${assessmentId}/memberDetails`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    if (result.status === "success") {
      return result.data;
    }
    else {
      throw new Error(result.message || 'Unexpected response status');
    }
  }
  catch (error) {
    // console.error('Failed to fetch client details:', error.message);
  }
};

export const fetchGroupReportPreviewData = async () => {

  const clientId = JSON.parse(localStorage.getItem("clientData"))?.id

  if (!clientId) {
    // console.log('No clientId available for preview API call');
    return;
  }

  try {
    const response = await authenticatedFetch(
      `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${clientId}`,
      {
        method: "GET",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status == "success") {
      const previewData = await response;

      return previewData;
    } else {
      // console.error('Preview API failed with status:', response.status);
    }
  } catch (error) {
    // console.error('Error calling preview API:', error);
  }
};

export const checkUserExist = async (email) => {
  try {
    const response = await fetch(
      `${process.env.VITE_API_URL}/v8/user/exists?assessmentId=78&email=${email}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      console.error(`API Error: ${response.status} ${response.statusText}`);
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Network/Parsing Error:", error);
    return null;
  }
};

export const fetchPreviewData = async (clientId) => {
  try {
    // console.log("Calling preview API with clientId:", clientId);
    const previewResponse = await authenticatedFetch(
      `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${clientId}`,
      {
        method: "GET",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
      }
    );

    // console.log("Preview API Response Status:", previewResponse);

    if (previewResponse && previewResponse?.data?.length > 0) {
      // console.log("Preview API Response Data:", previewResponse);

      // Store preview data separately in localStorage
      localStorage.setItem(
        "groupReportPreviewData",
        JSON.stringify(previewResponse)
      );
      // console.log( "Preview data stored successfully for clientId:", clientId );

      return previewResponse;
    } else {
      // console.error( "Preview API failed with status:", previewResponse.status );
      throw new Error(`Preview API failed with status: ${previewResponse.status}`);
    }
  } catch (error) {
    // console.error("Error calling preview API:", error);
    throw error;
  }
};

export const fetchAssessments = async (deploymentId) => {
  try {
    if (!deploymentId) {
      throw new Error('deploymentId is manadatory');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/deployments/${deploymentId}/assessments`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    if (result.status === "success") {
      return result.data;
    }
    else {
      throw new Error(result.message || 'Unexpected response status');
    }
  }
  catch (error) {
    // console.error('Failed to fetch client details:', error.message);
  }
};

export const fetchOrganisationDetails = async (orgId) => {
  try {
    if (!orgId) {
      throw new Error('orgId is mandatory');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    return result
  }
  catch (error) {
    // console.error('Failed to fetch organisation details:', error.message);
  }
};

export const fetchTransactionHistory = async (authCtx) => {
  try {
    const orgId = authCtx?.orgId || localStorage.getItem('orgId');
    if (!orgId) {
      throw new Error('orgId is not found in localStorage and in authCtx');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/stripe/purchases/${orgId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    return result?.data || [];
  } catch (error) {
    // console.error('Failed to fetch transaction history:', error.message);

    return [];
  }
};

export const fetchPaymentMethodId = async (customerId) => {

  const api_url = `https://api.stripe.com/v1/customers/${customerId}/payment_methods`

  const response = await fetch(api_url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${process.env.REACT_APP_STRIPE_API_KEY}`
    }
  })

  const result = await response.json();

  return result?.data;
}

export const fetchSavedCards = async (customerId, token) => {
  const api_url = `${process.env.REACT_APP_API_URI}/v5/stripe/saved-cards/${customerId}/tl`

  const response = await fetch(api_url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    }
  })

  const result = await response.json();

  return result?.cards;
}

export const fetchTokens = async ({ orgId, tokens }) => {
  try {
    if (!orgId) {
      throw new Error('deploymentId is manadatory');
    }
    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    if (result.status === "success") {
      return result.data;
    }
    else {
      throw new Error(result.message);
    }
  }
  catch (error) {
    // console.error('Failed to fetch client details:', error.message);
  }
}

const waitMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Poll v8 PDF job status until URL is ready.
 * First poll waits 7–10s; later polls use a shorter interval.
 */
const pollForPdfUrl = async (pollUrl, { intervalMs = 3000, maxAttempts = 20 } = {}) => {
  const apiBase = process.env.REACT_APP_API_URI || '';
  const fullPollUrl = pollUrl.startsWith('http') ? pollUrl : `${apiBase}${pollUrl}`;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    if (attempt === 1) {
      const firstWaitMs = 7000 + Math.floor(Math.random() * 3001); // 7–10s
      await waitMs(firstWaitMs);
    } else {
      await waitMs(1000 + Math.floor(Math.random() * intervalMs));
    }

    const data = await authenticatedFetch(fullPollUrl, { method: 'GET' });

    if ((data?.status === 'success' || data?.status === 'completed') && data?.url) {
      return data.url;
    }

    if (data?.status === 'failed' || data?.status === 'failure') {
      throw new Error(data?.error || data?.message || 'PDF generation failed');
    }
  }

  throw new Error('PDF generation timed out. Please try again later.');
};

const resolvePdfJobResult = async (data) => {
  if (!data) throw new Error('Empty PDF generation response');

  if ((data.status === 'success' || data.status === 'completed') && data.url) {
    return { ...data, url: data.url };
  }

  if (data.status === 'success' && data.pollUrl) {
    const url = await pollForPdfUrl(data.pollUrl);
    return { ...data, status: 'success', url };
  }

  throw new Error(data.message || 'Failed to generate PDF');
};

export const generatePDFById = async (id, pages, authCtx, reportDetail) => {
  const orgId = authCtx?.orgId || localStorage.getItem('orgId');
  const apiUrl = `${process.env.REACT_APP_API_URI}/v8/generate-combined-pdf`;

  const pageArray = typeof pages === 'string' ? pages.split(',') : pages;

  const payload = {
    ids: [id],
    pages: pageArray,
    reportType: 'self-report',
    reportDetail: {
      ...(reportDetail || {}),
      ...(orgId != null ? { orgId } : {}),
    },
  };

  try {
    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-org-id': orgId,
      },
      body: JSON.stringify(payload),
    });

    return resolvePdfJobResult(result);
  } catch (error) {
    throw error;
  }
};

export const fetchVariables = async (teamId) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Auth token is missing");
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${teamId}/variables`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    const result = await response.json();

    if (result.status === "success") {
      return result.data;
    } else {
      throw new Error(result.message || "Unexpected response status");
    }
  } catch (error) {
    console.error("Failed to fetch report variables:", error.message);
    throw error;
  }
};

export const fetch360ReportData = async (assessmentHash) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v3/user/assessment/${assessmentHash}/results`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (result.status === "success") {
      return result;
    } else {
      throw new Error(result.message || "Failed to fetch 360 report data");
    }
  } catch (error) {
    console.error("Error in fetch360ReportData:", error);
    throw error;
  }
};

export const fetchSelfReportData = async (selectedId) => {
  try {
    const data = await fetchVariables(selectedId);
    return data?.results?.[0];
  } catch (error) {
    // console.error("Error in fetchSelfReportData:", error);
    throw error;
  }
};

// POST calls
export const addObservers = async ({ assessmentId, data }) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v1/assessment/share/${assessmentId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(data)
    });

    return result
  }
  catch (error) {
    // console.error('Failed to add observers:', error.message);
  }
};

export const createAssessmentAndUser = async (payload) => {
  try {
    console.log("Payload:", payload);

    const result = await authenticatedFetch(
      process.env.REACT_APP_API_URI + "/v8/user/tl/assessmentAndUser",
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );

    console.log("API Response:", result);

    if (result?.data?.status === "success") {
      return result;
    } else {
      console.error("Error response:", result);
      return result;
    }
  } catch (err) {
    console.error("Failed to create new assessment...", err);
    return { error: err.message };
  }
};


export const createCustomer = async (email, name, orgId, paymentMethodId) => {
  try {
    const result = await authenticatedFetch(
      `${process.env.REACT_APP_API_URI}/v5/stripe/customer/tl`,
      {
        method: "POST",
        body: JSON.stringify({
          email,
          name,
          paymentMethodId,
          orgId
        }),
      }
    );

    return result;
  } catch (error) {
    // console.error("Error creating customer:", error);
    return null;
  }
};

export const buyTokensStripe = async (tokenPayload) => {
  try {
    const result = await authenticatedFetch(`${process.env.REACT_APP_API_URI}/v5/stripe/customer/intent/tl`, {
      method: 'POST',
      body: JSON.stringify(tokenPayload)
    })

    if (result?.status == "success") {
      return result;
    }
    else {
      // console.log("error creating payment intent", result)
    }

  }
  catch (error) {
    // console.log("error in payment", error)
  }
}

export const transactionHistory = async (data) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/stripe/purchase/tl`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(data),
    });

    return result;
  } catch (error) {
    // console.error('Failed to export transaction history:', error.message);
    throw error;
  }
};

export const createClientDeployment = async (requestBody, authCtx) => {
  const orgId = authCtx?.orgId || localStorage.getItem('orgId');
  const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}/deployments`;

  try {
    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(requestBody),
    });

    return result;
  } catch (error) {
    // console.error('API Error:', error);
    throw error;
  }
};

export const generateCombinedPDF = async (requestBody, authCtx) => {
  const orgId = authCtx?.orgId || localStorage.getItem('orgId');
  const apiUrl = `${process.env.REACT_APP_API_URI}/v8/generate-combined-pdf`;

  const payload = {
    ...(requestBody || {}),
    reportDetail: {
      ...(requestBody?.reportDetail || {}),
      ...(orgId != null && !requestBody?.reportDetail?.orgId ? { orgId } : {}),
    },
  };

  try {
    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return resolvePdfJobResult(result);
  } catch (error) {
    throw error;
  }
};


// Self-report generation API
export const generateSelfReport = async ({ authToken, clientId, assessment_hash, userName }) => {
  const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview`;
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        deploymentId: clientId,
        filename: 'team_config.json',
        assessment_hash,
        members: [assessment_hash],
        type: 'self',
        teamname: userName || 'Resp',
      }),
    });
    const data = await response.json();
    return data;
  } catch (err) {
    throw err;
  }
};

// PUT calls
export const updateAssessmentStatus = async ({ assessmentId, deploymentId, status }) => {
  try {
    if (!assessmentId || !deploymentId || !status) {
      throw new Error('Something is missing!');
    }
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/deployments/${deploymentId}/assessment/${assessmentId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'PUT',
      body: JSON.stringify({ status: status })
    });

    return result
  }
  catch (error) {
    // console.error('Failed to fetch organisation details:', error.message);
  }
};

export const updateTokens = async ({ orgId, token }) => {
  // console.log("orgId,token", orgId, token)

  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/details/${orgId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'PUT',
      body: JSON.stringify({
        properties: [
          { "property": "orgTotalTokens", "value": `${token}` }
        ]
      })
    });

    return result;
  } catch (error) {
    // console.error("Error in fetchTokens:", error);
    throw error;
  }
};

export const updateOrgInfo = async ({ orgId, orgName }) => {
  // console.log("orgId,token", orgId, token)

  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'PUT',
      body: JSON.stringify({ orgName })
    });

    return result;
  } catch (error) {
    // console.error("Error in fetchTokens:", error);
    throw error;
  }
};

export const updateAssessment = async (id, payload) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/user/tl/assessment/${id}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

    return result;
  } catch (error) {
    // console.error('Update Error:', error);
    throw error;
  }
};

// DELETE calls
export const deleteDeployment = async ({ orgId, deploymentId }) => {
  const resolvedOrgId = orgId || localStorage.getItem('orgId');
  if (!resolvedOrgId || !deploymentId) {
    throw new Error('orgId and deploymentId are required');
  }
  const apiUrl = `${process.env.REACT_APP_API_URI}/v6/organisation/${resolvedOrgId}/deployments/${deploymentId}`;

  const result = await authenticatedFetch(apiUrl, {
    method: 'DELETE',
  });

  if (result?.statusCode === 500 || result?.status === 'error' || (result?.status && result.status !== 'success')) {
    throw new Error(result?.message || result?.error?.details || 'Error deleting deployment');
  }
  return result;
};

export const deleteAssessment = async ({ assessmentId, deploymentId }) => {
  try {
    if (!assessmentId || !deploymentId) {
      throw new Error('Something is missing!');
    }
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/deployments/${deploymentId}/assessment/${assessmentId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'DELETE',
    });

    return result
  }
  catch (error) {
    // console.error('Failed to fetch organisation details:', error.message);
  }
};

export const submitSupportRequest = async ({ name, email, subject, message, attachments = [] }) => {
  const baseUrl = process.env.REACT_APP_API_URI;
  const assessmentId = process.env.REACT_APP_SUPPORT_ASSESSMENT_ID || process.env.REACT_APP_CLIENT_ID;
  const safeEmail = (email || '').trim();
  const supportInbox = (process.env.REACT_APP_SUPPORT_EMAIL || safeEmail || '').trim();

  if (!baseUrl) {
    throw new Error('Support API base URL is not configured');
  }

  if (!assessmentId) {
    throw new Error('Support assessment id is not configured');
  }

  const apiUrl = `${baseUrl}/v6/assessment/${assessmentId}/send-email`;

  const sanitize = (value = '') => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const safeName = (name || '').trim();
  const sanitizedMessage = sanitize(message).replace(/\n/g, '<br />');
  const sanitizedSubject = sanitize(subject?.trim() || 'Quadrant Flow Assessment');

  const formattedBody = `
  <body style="margin: 0; padding: 0;">
  <div style="width: 100%;background: #0000000D">
    <div style="max-width: 600px;width: 100%;margin: 0 auto; font-family: 'Lato', sans-serif; background-color: #ffffff;">
      <table style="width: 100%;margin: 0;" cellpadding="0" cellspacing="0">
        <tr style="padding: 0; margin-bottom: 0;">
          <td style="padding: 0;"><img src="[headerImage]"  style="width: 100%;"></td>
        </tr>
        <tr style="padding: 0; margin-top: 0;">
          <td
            style="width: 100%;background: #FFFFFF;color: #245775; padding: 12px 14px 24px;font-family: 'Lato', sans-serif; font-size: 14px;">
            <div style="max-width: 411px; margin: 0 auto;">
              <p>${sanitizedMessage || '[Description of the issue or request here — e.g., what is expected to happen vs. what actually happened.]'}</p>
             <hr style="border: 0; border-top: 1px solid #245775; margin: 40px 0 24px;"> 
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</body>`;
  const firstName = safeName.split(' ')[0] || 'Friend';

  const details = {
    // to: "rob@transformedleader.com",
    to: "robsupporttest@studio137.co.za",
    subject: subject?.trim() || 'Support Request - Consultant Portal',
    body: formattedBody,
    firstName,
    fullName: safeName || firstName,
    email: safeEmail,
    summary: message?.slice(0, 120) || '',
    replyToEmail: safeEmail,
    replyToName: safeName || firstName,
  };

  const payload = new FormData();
  payload.append('automationType', 'contact_support_client_email');
  payload.append('details', JSON.stringify(details));

  attachments.forEach((file) => {
    payload.append('attachments', file);
  });

  return authenticatedFetch(apiUrl, {
    method: 'POST',
    body: payload,
  });
};


// Firebase calls

// types = self_complete, 360_complete, all_complete, asmt_reminder, client_added

export const sendNotifications = async ({ action, action_link, msg, user_name, type, orgId, asmtId, clientId }) => {
  const db = getDatabase(app);
  const dbRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);

  try {
    // Fetch existing notifications
    const snapshot = await get(dbRef);

    if (snapshot.exists()) {
      const notifications = Object.values(snapshot.val() || {});
      const isDuplicate = notifications.some(
        (n) =>
          n.clientId === clientId &&
          n.message === msg &&
          (asmtId ? n.asmtId === asmtId : true)
      );
      if (isDuplicate) {
        // console.log("Duplicate notification blocked:", { clientId, asmtId, msg });
        return;
      }
    }

    const notificationsRef = push(dbRef);
    await set(notificationsRef, {
      id: `portal-${nanoid()}`,
      action: action,
      action_link: action_link,
      message: msg,
      user_name: user_name,
      orgId: orgId,
      clientId: clientId,
      asmtId,
      notification_type: type,
      reference_id: process.env.REACT_APP_CLIENT_ID,
      timestamp: new Date().toISOString()
    });

    // console.log("Notification sent.");
  } catch (error) {
    // console.error("Error sending notification:", error);
  }
};

export const listenForNotifications = (callback) => {
  const db = getDatabase(app);
  const dbRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);

  const listener = onValue(dbRef, (snapshot) => {
    if (snapshot.exists()) {
      const notifications = Object.values(snapshot.val() || {});
      // console.log('notifications', notifications)
      callback(notifications);
    } else {
      callback([]);
    }
  });

  // Return a cleanup function to detach the listener
  return () => off(dbRef, 'value', listener);
};

export const deleteNotificationById = async (id) => {
  const db = getDatabase(app);
  const notificationsRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);

  try {
    const snapshot = await get(notificationsRef);
    if (snapshot.exists()) {
      const data = snapshot.val();

      // Find the first matching notification
      const entry = Object.entries(data).find(([key, value]) => value.id === id);

      // console.log("notification entry", entry)

      if (entry) {
        const [key] = entry;
        await remove(ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}/${key}`));
        // console.log(`notification with id ${id} deleted.`);
      } else {
        // console.log(`No notification found with id ${id}.`);
      }
    }
    else {
      // console.log("No notifications found.");
    }
  } catch (error) {
    // console.error("Error deleting notification:", error);
  }
};

export const deleteNotificationsByOrgId = async (orgId) => {
  const db = getDatabase(app);
  const notificationsRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);
  const snapshot = await get(notificationsRef);

  const deletePromises = [];

  if (snapshot.exists() && orgId) {
    snapshot.forEach((childSnapshot) => {
      const notification = childSnapshot.val();
      if (notification.orgId == orgId) {
        const notificationRef = child(notificationsRef, childSnapshot.key);
        deletePromises.push(remove(notificationRef));
      }
    });
  }

  await Promise.all(deletePromises);
  // console.log(`Deleted notifications for orgId ${orgId}.`);
};

export const updateNotificationById = async (id) => {
  const db = getDatabase(app);
  const notificationsRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);

  try {
    const snapshot = await get(notificationsRef);
    if (snapshot.exists()) {
      const data = snapshot.val();

      // Find the first matching notification
      const entry = Object.entries(data).find(([key, value]) => value.id === id);

      // console.log("notification entry", entry)

      if (entry) {
        const [key] = entry;
        await update(ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}/${key}`), { isRead: true });
        // console.log(`notification with id ${id} is read.`);
      } else {
        // console.log(`No notification found with id ${id}.`);
      }
    }
    else {
      // console.log("No notifications found.");
    }
  } catch (error) {
    // console.error("Error updating notification:", error);
  }
};

export const markAllNotificationsAsUnRead = async () => {
  const db = getDatabase(app);
  const notificationsRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);
  const snapshot = await get(notificationsRef);

  const updatePromises = [];

  if (snapshot.exists()) {
    snapshot.forEach((childSnapshot) => {
      const notificationKey = childSnapshot.key;
      const notificationRef = child(notificationsRef, notificationKey);

      // Only push update if it's currently unread
      const { isRead } = childSnapshot.val();
      if (isRead) {
        updatePromises.push(update(notificationRef, { isRead: false }));
      }
    });
  }

  await Promise.all(updatePromises);
  // console.log("All notifications marked as unread.");
};

export const markAllNotificationsAsReadByOrgId = async (orgId) => {
  const db = getDatabase(app);
  const notificationsRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);
  const snapshot = await get(notificationsRef);

  const updatePromises = [];

  if (snapshot.exists() && orgId) {
    snapshot.forEach((childSnapshot) => {
      const notificationKey = childSnapshot.key;
      const notificationRef = child(notificationsRef, notificationKey);
      const notification = childSnapshot.val();

      // Only push update if it's currently unread
      if (!notification.isRead && notification.orgId === orgId) {
        updatePromises.push(update(notificationRef, { isRead: true }));
      }
    });
  }

  await Promise.all(updatePromises);
  // console.log("All notifications marked as unread.");
};

// Team name validation APIs
export const checkTeamNameExists = async (deploymentId) => {
  try {
    if (!deploymentId) {
      throw new Error('deploymentId is mandatory');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${deploymentId}`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'GET',
    });

    return result;
  } catch (error) {
    // console.error('Failed to check team name existence:', error.message);
    throw error;
  }
};

export const createTeamName = async ({ deploymentId, filename, members, type, teamname }) => {
  try {
    if (!deploymentId || !filename || !members || !type || !teamname) {
      throw new Error('All parameters are mandatory');
    }

    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview`;

    const result = await authenticatedFetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify({
        deploymentId,
        filename,
        members,
        type,
        teamname
      }),
    });

    return result;
  } catch (error) {
    // console.error('Failed to create team name:', error.message);
    throw error;
  }
};

export const deleteTeam = async (teamId) => {
  // console.log("delete team", teamId)
  try {
    const result = await authenticatedFetch(`${process.env.REACT_APP_API_URI}/v5/organisations/tl/preview/${teamId}`, {
      method: 'DELETE',
    });

    return result;
  } catch (error) {
    // console.error('Error deleting team:', error);
    throw error;
  }
};
